import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SideMenuComponent } from './navigation/side-menu/side-menu.component';
import { FooterComponent } from './navigation/footer/footer.component';
import { MaterialModule } from '../material/material.module';
import { ToolbarComponent } from './navigation/toolbar/toolbar.component';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';
import { NotificationsModule } from '../notifications/notifications.module';
import { SystemstatustooltipComponent } from './navigation/toolbar/tooltips/systemstatustooltip/systemstatustooltip.component';

@NgModule({
  declarations: [
    SideMenuComponent,
    FooterComponent,
    ToolbarComponent,
    SystemstatustooltipComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    SharedModule,
    RouterModule,
    NotificationsModule
  ],
  exports: [
    SideMenuComponent,
    FooterComponent,
    ToolbarComponent
  ]
})
export class CoreModule { }
